import { render, staticRenderFns } from "./DamageTimeline.vue?vue&type=template&id=3c246d43"
import script from "./DamageTimeline.vue?vue&type=script&lang=ts"
export * from "./DamageTimeline.vue?vue&type=script&lang=ts"
import style0 from "./DamageTimeline.vue?vue&type=style&index=0&id=3c246d43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports